import type { IntlShape } from 'react-intl';
import type { AlertDefinition } from '@qronstat/shared';
import { formatValue } from '../../model/format';

export function describeRule(
  rule: { definition: AlertDefinition },
  intl: IntlShape,
  metricTitle: string,
  format: Parameters<typeof formatValue>[1],
  locale: 'ru' | 'en',
): string {
  const c = rule.definition.condition;
  const window = rule.definition.window;
  const w =
    window.kind === 'minutes'
      ? intl.formatMessage({ id: 'alerts.describe.minutes' }, { n: window.minutes })
      : intl.formatMessage({ id: `alerts.describe.${window.kind}` });
  if (c.kind === 'threshold')
    return intl.formatMessage(
      { id: 'alerts.describe.threshold' },
      {
        metric: metricTitle,
        window: w,
        op: intl.formatMessage({ id: `filters.op.${c.operator === 'eq' ? 'equals' : c.operator}` }),
        value: formatValue(c.value, format, locale),
      },
    );
  if (c.kind === 'deviation')
    return intl.formatMessage(
      { id: 'alerts.describe.deviation' },
      {
        metric: metricTitle,
        window: w,
        direction: intl.formatMessage({ id: `alerts.direction.${c.direction}` }),
        percent: c.percent,
        weeks: c.weeks,
      },
    );
  return intl.formatMessage(
    { id: 'alerts.describe.noActivity' },
    { metric: metricTitle, window: w, weeks: c.weeks },
  );
}
